module.exports = __webpack_public_path__ + "img/me_icon_record@3x.30e7bfee.png";